// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__VM_-S","label":"CategoryService_label__NAKe-","location":"CategoryService_location__32Xo5"};